
import SearchBar from '@/components/SearchV3/index.vue';

export default {
  components: {
    SearchBar: SearchBar
  },

  props: {
    handleResetSearch: {
      type: Function,
      default: function _default() {}
    },
    handleSearch: {
      type: Function,
      default: function _default() {}
    },
    query: {
      type: Object,
      required: true
    },
    formItemList: {
      type: [Object, Array],
      required: true
    },
    handleBatchAction: {
      type: Function,
      default: function _default() {}
    },
    handleExport: {
      type: Function,
      default: function _default() {}
    },
    currentTab: {
      type: String,
      default: ''
    },
    batchIds: {
      type: String,
      default: ''
    }
  }
};